'use strict'
const {
    migrateStylableComponentsByCompType
} = require('../helpers/stylableMigration/migrateStylableComponentsByCompType')

const COMPTYPE = 'wixui.SelectableContainerInput'
const NON_STYLABLE_SKIN = 'wixui.skins.SelectableContainerInput'

const CSS_LABEL_PROP_TO_VAR_NAME = {
    'text-decoration-line': 'text-decoration',
    'background-color': 'text-highlight'
}

const CSS_INPUT_PROP_TO_VAR_NAME = {
    width: 'button-size'
}

const migratePage = (structure, data, uniqueIdGenerator, clientSpecMap, magicObject) => {
    migrateStylableComponentsByCompType({
        magicObject,
        structure,
        data,
        uniqueIdGenerator,
        clientSpecMap,
        newSkin: NON_STYLABLE_SKIN,
        compType: COMPTYPE,
        useCssColor: true,
        selectorsMappings: {
            '.root::label': {
                name: 'label',
                removePrefix: true,
                properties: CSS_LABEL_PROP_TO_VAR_NAME
            },
            '.root::customInput': {
                removePrefix: true,
                name: 'customInput',
                properties: CSS_INPUT_PROP_TO_VAR_NAME
            }
        },
        postStyleMigrationCallback: (migratedStyle, originalStyle) => {
            const {properties} = migratedStyle
            const {properties: originalProperties} = originalStyle
            // eslint-disable-next-line no-unused-vars
            const {'$st-css': _, ...rest} = originalProperties
            return {...migratedStyle, properties: {...properties, ...rest}}
        }
    })
}

// DRAFT MIGRATION - this migration is not complete missing bug fixes & tests
// Should add test like this @see santa-data-fixer/test/plugins/stylableDeprecation/stylableMigrationUtils.unit.js
module.exports = {
    name: 'selectableContainerInputStylesFixer',
    version: 0,
    experimentalVersions: [
        {experiment: 'dm_migrateSelectableContainerInput', version: 1},
        {experiment: 'dm_migrateBlocksWidgetsToNonStylable', version: 2}
    ],
    exec(pageJson, pageIdsArray, magicObject) {
        const {clientSpecMap} = magicObject
        const {uniqueIdGenerator} = magicObject.dataFixerUtils

        if (!magicObject.isExperimentOpen('dm_migrateSelectableContainerInput')) {
            return
        }

        const {data, structure} = pageJson
        migratePage(structure, data, uniqueIdGenerator, clientSpecMap, magicObject)
    },
    fixerRequiresReruns: true
}
